<template>
  <div class="churn-goodbye-page">
    <div class="content">
      <img class="top-visual" :src="require(`@/assets/check-with-green-circle.svg`)"/>
      <div class="title">החשבון שלך וכל הפרטים הקשורים אליו יימחקו תוך 48 שעות</div>
      <div class="text">נשמח לצמוח איתך ביחד בהמשך.</div>
      <div class="text">בינתיים, כדי שנוכל להשתפר, נשמח לדעת</div>
      <div class="text bold">למה החלטת לעזוב.</div>
      <div class="text bottom-text">זה ייקח פחות מדקה.</div>
    </div>
    <div class="button-container">
      <riseup-button class="survey-button"
                     :title="'לענות על הסקר'"
                     variant="primary"
                     size="small"
                     :action="startSurveyClicked"/>
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '@/Segment';

export default {
  name: 'ChurnGoodbyePage',
  props: {
    startSurvey: {
      type: Function,
      require: true,
    },
  },
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  methods: {
    startSurveyClicked() {
      Segment.trackUserInteraction('StartSurveyClicked');
      this.startSurvey();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';

.churn-goodbye-page {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 50px 28px 30px;
  text-align: center;

  .content {
    flex-grow: 1;
    margin-bottom: 28px;

    .top-visual {
      height: 120px;
      margin-bottom: 30px;
    }

    .title {
      margin-bottom: 30px;
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
    }

    .text {
      font-size: 18px;
      line-height: 24px;
    }

    .bottom-text {
      margin-top: 24px;
    }

    .bold {
      font-weight: bold;
    }
  }

  .button-container {
    flex-grow: 0;
    .survey-button {
      width: 100%;
      height: 75px;
    }
  }
}
</style>
